import { render } from "./MiezzFormItem.vue?vue&type=template&id=473cef71&scoped=true&ts=true"
import script from "./MiezzFormItem.vue?vue&type=script&lang=ts"
export * from "./MiezzFormItem.vue?vue&type=script&lang=ts"

import "./MiezzFormItem.vue?vue&type=style&index=0&id=473cef71&lang=sass"
import "./MiezzFormItem.vue?vue&type=style&index=1&id=473cef71&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473cef71"]])

export default __exports__